import {DomainObject} from 'shared/store';
import { observable, makeObservable } from 'mobx';
import {Employee} from '../employees';

class Celebration extends DomainObject {
  employee;
  publishedAt;

  _relations = {
    employee: Employee,
    _dates: ['publishedAt']
  };

  constructor(other) {
    super();

    makeObservable(this, {
      employee: observable,
      publishedAt: observable
    });

    this.merge(other);
  }
}

export default Celebration;
